import { Component, OnInit, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { MenuItem } from '@teamfoster/sdk/menu-ngrx';
import { JsonLdComponent } from 'src/app/seo/components/json-ld/json-ld.component';
import { SocialChannelButtonsComponent } from 'src/app/social-media/components/social-channel-buttons/social-channel-buttons.component';
import { SocialChannel } from 'src/app/social-media/models';
import { TeamCtaComponent } from '../team-cta/team-cta.component';
import { LinkComponent } from '@teamfoster/sdk/button';

import * as fromMenu from '@teamfoster/sdk/menu-ngrx';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    FromDictionaryPipe,
    JsonLdComponent,
    RouterModule,
    IconComponent,
    SocialChannelButtonsComponent,
    TeamCtaComponent,
    LinkComponent,
    fromMenu.OfMenuTypePipe,
  ],
})
export class FooterComponent implements OnInit {
  private dict = new FromDictionaryPipe();

  domain = input<string>('');
  menu = input<MenuItem[]>([]);
  bottomMenu = input<MenuItem[]>([]);
  socials = input<SocialChannel[]>([]);
  schema = input<any>({
    '@context': 'http://schema.org',
    '@type': this.dict.transform('footer-json-ld-meta-type'),
    'name': this.dict.transform('meta-titel'),
    'url': this.domain,
    'logo': `${this.domain}/assets/gfx/logo.svg`,
    'contactPoint': {
      '@type': 'ContactPoint',
      'email': this.dict.transform('contact-email'),
      'contactType': 'customer service',
    },
    'sameAs': [],
  });

  year = new Date().getFullYear();

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.socials().forEach(s => {
      const socialLink = s.url; // to do config with social buttons
      this.schema().sameAs.push(socialLink);
    });
  }

  openCookie() {
    this.store.dispatch(ShowCookieSettings());
  }
}
